export default {
  banner: {
    title: "加入 Authing，遇到更优秀的你",
    subtitle: "成为世界一流的计算机科学、身份安全、数据和企业管理专家团队中的一员",
  },
  work: {
    title: "团队心中的 Authing",
    imgurl: "//files.authing.co/authing-website/joinus-common.png",
  },
  jobs: {
    title: "我们的职位",
    subtitle: '简历请投递至：lewisli@authing.cn，邮件标题为“招聘-岗位名称-姓名"',
    tabs: {
      "tab-one": "全部",
      "tab-two": "产研类",
      "tab-three": "商业化",
      "tab-four": "其他",
    },
    "button-apply": "立即申请",
    "job-one": {
      title: "全栈开发工程师",
      intro: `参与公司对外产品的前后端基础架构的设计与实现，提供稳定可靠的服务...`,
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 参与公司对外产品的前后端基础架构的设计与实现，提供稳定可靠的服务；",
        item1: "2. 负责内部平台的前后端架构设计与实现；",
        item2: "3. 负责技术攻关和创新技术引用，解决产品开发过程中的高性能，高并发和高可靠性问题；",
        item3: "4. 负责公司云服务产品及开发者平台的研发工作；",
        item4: "5. 调研公司研发体系和流程，给出相应底层服务的平台设计和技术方案；",
        item5: "6. 将设计方案实现为具体的平台功能，持续跟踪结果、不断优化用户体验；",
        item6: "7. 参与设计平台数据结构和系统架构，通过 Node.js 实现平台中的部分服务；",
        item7: "8. 负责公司客户交付项目的架构设计和实现。",
      },
      skills: {
        item0: "1. 3 年以上互联网开发经验，对 Unix / Linux 有深入了解；",
        item1: "2. 出色的编码能力，精通 Node.js，熟悉常用的算法，熟悉开源框架，解决问题能力强；",
        item2: "3. 熟练掌握前端框架 React / Vue，熟悉前端工程化及组件化开发模式；",
        item3: "4. 对后端程序性能优化有丰富经验；",
        item4: "5. 掌握 Redis、MongoDB、MySQL 等存储系统原理及应用；",
        item5: "6. 对分布式计算，分布式存储的架构设计理念和动机有一定理解；",
        item6: "7. 对 HTTP 协议有深刻的理解，熟悉 TCP / IP 等网络协议；",
        item7:
          "8. 加分项：有 Python、Go、PHP 开发经验；参与或拥有开源项目，为开源社区贡献过代码；有大规模后端服务的设计和开发方面经验。",
      },
    },
    "job-two": {
      title: "前端开发工程师",
      intro: `参与公司中台项目的客户需求调研、系统设计和架构工作...`,
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 参与公司中台项目的客户需求调研、系统设计和架构工作；",
        item1: "2. 完成各模块开发、测试和部署工作；",
        item2: "3. 基于公司产品开发高质量、服务上百万用户的上层应用。",
      },
      skills: {
        item0: "1. 计算机基础扎实，熟悉数据结构、网络等；",
        item1: "2. 对至少一种 MV* 框架（例如 React 或 Vue 等）有深入的研究；",
        item2: "3. 了解后端技术栈，熟悉后端语言 Node.js ，熟悉与后端的协作模式；",
        item3: "4. 对用户体验、交互及用户需求分析等有一定了解，有产品或界面设计经验者优先；",
        item4:
          "5. 对云计算、IDaaS 或开发者相关的产品有认知、有实践经验者优先，熟悉 Serverless、FaaS、DevOps 相关技术者优先；",
        item5:
          "6. 有较高的技术热情和积极性者，有良好的沟通能力，能承受较强的工作压力，具有团队合作精神，能够站在用户的角度去理解问题，发掘不足，善于总结",
        item6: "7. 加分项：参与或主导过优秀的开源项目；有优秀的技术博文、博客。",
      },
    },
    "job-three": {
      title: "DevOps 开发工程师",
      intro: `负责自动化运维平台、DevOps 体系的搭建和维护...`,
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "负责自动化运维平台、DevOps 体系的搭建和维护；",
        item1: "负责研发生命周期的工具和系统，如持续集成、代码发布、容量规划、监控等。",
      },
      skills: {
        item0: "1. 熟悉至少一门开发语言，并具有完整的项目开发经验；",
        item1: "2. 熟悉云原生体系架构，熟悉 AWS，阿里云，腾讯云等公有云平台。熟悉 Terraform 编排工具；",
        item2: "3. 熟悉 Kubernetes 技术及其原理，有过深度 Kubernetes 实践经验；",
        item3: "4. 熟悉自动化运维管理工具（Puppet / Saltstack / Ansible），厌恶手工操作；",
        item4: "5. 熟练使用日志处理及分析相关经验，熟悉相关的组件，如：Kafka，ELK，Flume，Hive，Storm 等",
        item5: "6. 具有持续集成、持续交付和自动化发布的经验；",
        item6: "7. 学习能力强，工作积极主动，勤奋认真踏实，有服务意识；",
        item7: "8. 加分项：参与过完整的运维体系建立；有以下相关经验：资产管理平台、服务质量监控、SLA 管理。",
      },
    },
    "job-four": {
      title: "移动端开发工程师 Android / iOS",
      intro: "负责模块程序对 Android / iOS 平台，在各混合开发框架下打包成 SDK、适配并测试、以及技术支持...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "负责模块程序对 Android / iOS 平台，在各混合开发框架下打包成 SDK、适配并测试、以及技术支持。",
      },
      skills: {
        item0:
          "1. 熟悉 cocos2d，flutter，React Native，weex，uni-app 中一种或多种开源框架，有过其模块开发/修改的优先；",
        item1: "2. 熟悉网络、多线程、HTTP / HTTPS / Socket；",
        item2: "3. 精通 Android 平台的架构原理，熟悉 Java；",
        item3: "4. 具有 iOS 开发经验，熟悉 Object-C 和 Swift 语言。",
      },
    },
    "job-five": {
      title: "Node.js 研发工程师",
      intro: "参与公司对外产品的前后端基础架构的设计与实现，提供稳定可靠的服务;负责内部平台的前后端架构设计与实现...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1、参与公司对外产品的前后端基础架构的设计与实现，提供稳定可靠的服务;",
        item1: "2、负责内部平台的前后端架构设计与实现；",
        item2: "3、负责技术攻关和创新技术引用，解决产品开发过程中的高性能，高并发和高可靠性问题。",
        item3: "4、负责公司云服务产品及开发者平台的研发工作；",
        item4: "5、调研公司研发体系和流程，给出相应底层服务的平台设计和技术方案；",
        item5: "6、将设计方案实现为具体的平台功能，持续跟踪结果、不断优化用户体验；",
        item6: "7、参与设计平台数据结构和系统架构，通过 Node.js 实现平台中的部分服务；",
        item7: "8、负责公司客户交付项目的架构设计和实现；",
      },
      skills: {
        item0: "1、 3 年以上互联网开发经验，对 Unix/Linux 有深入了解；",
        item1: "2、 出色的编码能力，精通 Node.js，熟悉常用的算法，熟悉开源框架，解决问题能力强；",
        item2: "3、 熟练掌握前端框架 React/VUE，熟悉前端工程化及组件化开发模式；",
        item3: "4、 对后端程序性能优化有丰富经验；",
        item4: "5、 掌握 Redis、MongoDB、MySQL 等存储系统原理及应用；",
        item5: "6、 对分布式计算，分布式存储的架构设计理念和动机有一定理解；",
        item6: "7、 对 HTTP 协议有深刻的理解，熟悉 TCP/IP 等网络协议；",
        item7:
          "8、 加分项：有 Python、Go、PHP 开发经验；参与或拥有开源项目，为开源社区贡献过代码；有大规模后端服务的设计和开发方面经验。",
      },
    },
    "job-six": {
      title: "产品经理",
      intro: "负责产品的设计工作，包含产品架构及平台体系搭建，并能对产品模式进行创新...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1、负责产品的设计工作，包含产品架构及平台体系搭建，并能对产品模式进行创新；",
        item1: "2、研究市场需求和使用场景，通过需求调研、功能设计、策略制定、效果提升等构建标准化产品解决方案；",
        item2: "3、收集和分析市场及竞对信息，进行产品规划，并能进行产品的全面效果评估；",
        item3: "4、与团队配合完成产品的立项评审、计划、协调沟通、跟踪推进、保证产品迭代输出；",
        item4: "5、高效协同市场、研发、运营团队，共同达成目标；",
        item5: "6、负责产品增长功能迭代；",
        item6: "7、负责产品品牌建设。",
      },
      skills: {
        item0: "1、 有商业化产品经验，有从 0 到 1 搭建商业化体系者优先；",
        item1: "2、 良好的技术能力，有 1 年以上软件研发经验，云计算、IAM、IDaaS 相关工作经验者优先；",
        item2: "3、 熟悉整个商业化链条，了解主流平台商业化模式和产品设计方法；",
        item3: "4、 参与过产品从 0 到 1 阶段；",
        item4: "5、 可以独当一面；",
        item5: "6、 具备良好的沟通协调能力，能很好的和不同团队成员进行合作并承担较大的压力。",
      },
    },
    "job-seven": {
      title: "国产化规划经理",
      intro: "了解、调研和分析国产化软硬件目标市场及客户需求，研究和掌握产品市场环境，挖掘、收集、管理市场信息...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1、了解、调研和分析国产化软硬件目标市场及客户需求，研究和掌握产品市场环境，挖掘、收集、管理市场信息；",
        item1: "2、负责公司中长期产品线战略以及路线图规划，提出中长期规划和意见；",
        item2: "3、收集和提炼市场对产品的需求，对国产设备及软件产品规划；理解产品特色和优势。",
      },
      skills: {
        item0: "1、 本科以上学历，3 - 5 年行业经验，通信、机械、电子、计算机及相关专业；",
        item1: "2、 有国产化从业背景者优先，了解云计算、操作系统、信息安全、IDaaS、AD 其中任意技术；",
        item2: "3、 熟悉 AD、单点登录技术者优先；",
        item3: "4、 具有优秀的文档编写能力，熟练使用主流办公软件；",
        item4: "5、 具备良好的沟通协调技能、统筹协调能力、团队合作精神及抗压能力；",
        item5: "6、 熟悉国家政策和要求、从事过相关工作者优先。",
      },
    },
    "job-eight": {
      title: "UI 设计师",
      intro: "负责 Authing 控制台及相关产品的 UI 及部分 UE 设计工作...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1、负责 Authing 控制台及相关产品的 UI 及部分 UE 设计工作；",
        item1: "2、参与一些创意和运营设计，推动方案的设计和实施；",
        item2: "3、跟进产品开发，验收并优化交互、视觉、提升产品的品牌形象。",
      },
      skills: {
        item0: "1、 有 B 端产品的设计经验优先；",
        item1: "2、 熟悉网页和 APP 相关的设计规范，能清晰完整表达设计方案；",
        item2: "3、 对互联网产品和流行趋势有敏锐的洞察力，有设计创造力和激情；",
        item3: "4、 具有良好的沟通能力，能与产品及研发团队配合产出；",
        item4: "5、 熟练使用 Sketch、PS、AI 等软件；",
        item5: "6、 思维缜密逻辑性强，能承受高强度的工作压力。",
      },
    },
    "job-nine": {
      title: "技术支持工程师",
      intro: "负责支持和维护已实施 Authing SaaS 解决方案的客户，及时响应客户的技术问题...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1、负责支持和维护已实施 Authing SaaS 解决方案的客户，及时响应客户的技术问题；",
        item1: "2、负责解决客户问题并能够与客户建立良好的关系，并达到最高的客户满意度；",
        item2: "3、负责前期客户需求的对接，从专业角度给出合理性的建议；",
        item3: "4、负责解决开发生命周期中的各项问题，并提出相应的解决方案;",
        item4: "5、与公司其他部门协作。",
      },
      skills: {
        item0: "1、 了解软件开发基础知识和通用体系结构；",
        item1: "2、 具备 HTTP 知识，加密和基本安全概念；",
        item2: "3、 了解身份验证和授权概念；",
        item3: "4、 了解至少一种身份认证协议：OAuth2，OIDC，SAML，WS-FED，LDAP，Azure AD 等；",
        item4: "5、 精通至少一种编程语言，最好是 Node.js，JavaScript；",
        item5: "6、 2 年及以上的技术支持或软件开发经验；",
        item6: "7、 具有 2-5 年在中大型 To B 项目的分析管理经验；",
        item7: "8、 具备多任务处理能力，沟通能力，较强的协作能力与主观能动性。",
      },
    },
    "job-ten": {
      title: "身份解决方案工程师",
      intro: "负责对软件工程师、软件架构师和产品负责人进行培训，提供关于 Authing 的技术知识...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1、负责对软件工程师、软件架构师和产品负责人进行培训，提供关于 Authing 的技术知识；",
        item1: "2、负责支持客户公司的开发团队，了解客户需求；",
        item2: "3、负责熟悉 Authing 的产品能力以及基础技术和协议，并能够提出改进建议；",
        item3: "4、负责通过研究了解行业趋势及市场上其他竞品的情况。",
      },
      skills: {
        item0: "1、 具有一定的 To B 客户对接的经验以及较强的沟通能力；",
        item1: "2、 具有至少一种标准网络安全协议 OAuth，OAuth2，SAML，LDAP 的经验；",
        item2: "3、 具备 HTTP 经验，以及 HTML 应用程序和 REST 服务。包括使用浏览器中的开发工具来解释 HTTP；",
        item3: "4、 流量以及使用 HTTP 客户端 Curl 或 Postman 与 HTTP 服务进行交互的能力；",
        item4: "5、 具有至少两种编程语言的经验，JavaScript 与另一种静态类型语言；",
        item5: "6、 具有至少有两个后端技术栈，如 Node.js、Java 的经验，以及主流的前端技术栈如 React、Angular 的经验；",
        item6: "7、 具有构建完整技术栈应用程序（前端 SPA 或移动 App，后端 REST API ，数据库）的经验；",
        item7: "8、 具有托管完整的技术栈应用程序（Heroku，Azure，AWS）的能力。",
      },
    },
    "job-11": {
      title: "高级解决方案架构师",
      intro: "负责所在行业的解决方案架构设计工作，确保解决方案的架构具备长期竞争力以及确保架构能被执行...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 负责所在行业的解决方案架构设计工作，确保解决方案的架构具备长期竞争力以及确保架构能被执行；",
        item1:
          "2. 深入客户一线，了解所在行业的客户需求和痛点，挖掘客户深层次的需求，提出创新性解决方案并确保需求落地，从而帮助客户成功；",
        item2: "3. 负责支持我们整个客户成功组织解决复杂的技术解决方案或与客户有关的问题；",
        item3: "4. 负责与产品部门合作，从客户的角度出发提出相关新功能建议。",
      },
      skills: {
        item0: "1. 具备 5 年以上的软件行业相关经验，3 年以上的 SaaS 行业经验；",
        item1: "2. 较强的领导能力，能够根据优先级处理多个业务冲突；",
        item2: "3. 身份，认证和授权协议以及应用程序安全方面的工作知识；",
        item3: "4. 具有 Web 安全最佳实践和标准的经验；",
        item4: "5. 对软件开发过程和软件设计方法有深入了解，以及具备在 Node.js，.NET 或类似产品上的开发经验；",
        item5: "6. 具备在复杂解决方案环境中进行大规模技术实施的经验；",
        item6: "7. 具有设计和开发 API 和 RESTFul 服务的经验；",
        item7: "8. 具有云实施模式和平台（例如阿里云/AWS，Azure 和Heroku）的经验；",
        item8: "9. 具备技术解决方案相关经验；",
        item9: "10. 较强的抗压能力；",
        item10: "11. 能够与各个级别的利益相关者建立并维持牢固的工作关系，以便为客户和 Authing 实现双赢结果；",
        item11: "12. 优秀的书面和口头交流能力。",
      },
    },
    "job-12": {
      title: "高级解决方案工程师",
      intro: "负责为潜在客户提供产品演示，并通过问答环节，了解客户需求...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 负责为潜在客户提供产品演示，并通过问答环节，了解客户需求；",
        item1: "2. 负责与软件工程、运营，产品等多个业务部门进行合作；",
        item2: "3. 负责为客户提供 Authing 的解决方案；",
        item3: "4. 负责为潜在客户进行有效的 PoC；",
        item4: "5. 对 Authing 产品以及基础技术保持深入的技术理解；",
        item5: "6. 通过自学，研究，在线课程了解行业趋势；",
        item6: "7. 积极参与各项活动，使 Authing 成为演示者和参与者。",
      },
      skills: {
        item0: "1. 具有 5 年及以上的售前工程经验；",
        item1: "2. 具有在联邦和/或 SLED 帐户的流程和特性方面工作的经验；",
        item2: "3. 具有客户服务的经验，咨询或销售支持经验为佳；",
        item3: "4. 具有 JavaScript 经验；",
        item4: "5. 具有 SaaS 和云平台（AWS，阿里云等）的经验；",
        item5: "6. 具有至少一个后端技术栈（Node.js，Java，.NET）的经验；",
        item6: "7. 具有流行的前端技术栈（React，Angular）的经验；",
        item7: "8. 具有至少一种标准网络安全协议（OAuth，OAuth2，SAML，LDAP）的经验；",
        item8: "9. 了解典型应用程序中的核心安全问题（密码哈希，SSL / TLS，静态加密，XSS，XSRF）；",
        item9:
          "10. 具备 HTTP 经验，以及 HTML 应用程序和 REST 服务。这包括使用浏览器中的开发工具来解释HTTP 流量以及使用 HTTP 客户端（Curl 或 Postman）与 HTTP 服务进行交互的能力；",
        item10: "11. 具有时间管理，项目管理技能，以及多部门协作能力；",
        item11: "12. 具有较强的表达能力和即时演讲能力。",
      },
    },
    "job-13": {
      title: "系统工程师",
      intro: "负责解决客户的新出现的问题，提供故障排除，分类，诊断和解决方案...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 负责解决客户的新出现的问题，提供故障排除，分类，诊断和解决方案；",
        item1: "2. 负责维护和更新平台基础架构，在云上部署并保护新的专用私有客户环境；",
        item2: "3. 负责执行应用程序设置，集成，配置和更新；",
        item3: "4. 负责扩充并完善 Authing 的操作文档；",
        item4: "5. 较强的协作能力，与组织中的其他许多技术和服务团队合作。",
      },
      skills: {
        item0:
          "1. 了解阿里云/AWS 的服务和资源，例如在 AWS 中的 EC2，EBS，ELB / ALB，VPC，RDS，SNS，S3，Kinesis，Lambda，IAM 等；",
        item1: "2. 熟悉 Ubuntu Linux，Nginx，MongoDB，Docker，ElasticSearch，Postgres 等；",
        item2: "3. 了解以下至少两种及以上常见协议，例如 HTTP，TLS / SSL，DNS，SSH，TCP / IP；",
        item3: "4. 能够使用以下至少一种自定义部署工具，如 Terraform / Ansible；",
        item4: "5. 能够使用 Git 和 Github 进行版本控制。",
      },
    },
    "job-14": {
      title: "客户销售开发代表",
      intro: "主动通过电话、社交媒体、相关展会等多种途径联系潜在客户，并挖掘客户潜在需求...",
      experience: "经验 5 年以上 / 本科",
      description: {
        item0: "1. 主动通过电话、社交媒体、相关展会等多种途径联系潜在客户，并挖掘客户潜在需求；",
        item1: "2. 分析客户需求，针对客户需求提出对应文档信息化解决方案；",
        item2:
          "3. 针对客户不同的业务场景，负责客户前期接洽、跟进、拟定销售策略、商务谈判、客情维护等工作，促成销售目标达成。",
      },
      skills: {
        item0: "1. 具备良好的销售跟客户服务能力；",
        item1: "2. 具备一年以上 SaaS 行业，销售代表经验；",
        item2: "3. 性格开朗，优秀的表达能力和沟通技巧，能适应不定期出差；",
        item3: "4. 对工作有高度热情，抗压能力强，良好的团队合作精神，创造性思维。",
      },
    },
    "job-15": {
      title: "中小企业客户经理",
      intro: "负责给客户提供专业的解决方案并实时跟进...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 负责给客户提供专业的解决方案并实时跟进；",
        item1: "2. 掌握行业动态，通过分析内部各项数据来正确预测月度和季度收入；",
        item2: "3. 积极开拓市场，建立与行业客户的良好合作；",
        item3: "4. 负责维护客户关系，促成长期合作；",
        item4: "5. 通过 CRM 管理客户和完善销售流程。",
      },
      skills: {
        item0: "1. 具有 1 年以上的 SaaS 销售经验，销冠经验更佳；",
        item1: "2. 具备较强的沟通能力，谈判能力；",
        item2: "3. 具备多任务管理能力，组织能力；",
        item3: "4. 熟练使用办公软件。",
      },
    },
    "job-16": {
      title: "大企业客户经理",
      intro: "负责制定并执行战略客户销售计划；通过识别、管理和扩展销售机会来达到预期目标，以及完善销售制度...",
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 负责制定并执行战略客户销售计划；",
        item1: "2. 通过识别、管理和扩展销售机会来达到预期目标，以及完善销售制度；",
        item2: "3. 通过我们的 CRM 系统开发和管理销售，以准确的预测月度、季度销售额；",
        item3: "4. 负责开拓市场，开发新的渠道，与合作伙伴、供应商建立良好的战略合作关系；",
        item4: "5. 负责管理内部 CRM 系统，并协调资源以支持客户销售、客户成功团队；",
        item5: "6. 负责调研分析竞品，保证 Authing 快速迭代；",
        item6: "7. 负责与内部的市场、产研等部门团队协作，按时完成本部门工作；",
        item7: "8. 负责大客户的开拓工作，如有必要，需要出差。",
      },
      skills: {
        item0: "1. 具有 3 年以上 To B 的 SaaS 销售管理经验，5 年以上的销售经验，销冠经验更佳；",
        item1: "2. 具备较强的沟通能力、谈判能力、自我管理能力；",
        item2: "3. 具备多任务管理能力、组织能力、团队协作能力；",
        item3: "4. 具有身份，安全或开发人员对接相关的经验者优先；",
        item4: "5. 熟练使用办公软件。",
      },
    },
    "job-17": {
      title: "政务客户经理",
      intro: `作为公共部门客户经理，你将负责在政务客户（政府/园区/卫生部门等）的企业级客户中，推动 Authing 身份管理平台的销售和扩展...`,
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 定义并执行战略客户销售计划；",
        item1: "2. 通过确定、管理和完成扩展并获得新的销售机会来达到并超越销售目标，从而确保客户留存率；",
        item2: "3. 通过 CRM 系统开发和管理销售渠道；",
        item3: "4. 担任所有客户的主要客户联系人并协调资源以支持售前和售后的工作；",
        item4: "5. 具备与管理层，客户和合作伙伴进行有效，出色的沟通能力；",
        item5: "6. 接受不定期出差，例如到客户所在地支持销售工作。",
      },
      skills: {
        item0: "1. 在政务部门/和政务客户有 3 年以上的企业软件销售经验；",
        item1: "2. 具备出色的沟通技巧以及双赢心态的强大商务谈判能力；",
        item2: "3. 具备自主工作能力和根据实际情况在团队中互相协作的工作能力；",
        item3: "4. 强大的组织能力来管理多个销售机会和客户需求；",
        item4: "5. 具备身份安全领域工作经验者优先。",
      },
    },
    "job-18": {
      title: "技术运营",
      intro: `负责 Authing 的产品推广及运营，打造用户运营体系，探索并制定 Authing 的整体推广计划...`,
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 负责 Authing 的产品推广及运营，打造用户运营体系，探索并制定 Authing 的整体推广计划；",
        item1: "2. 负责 Authing 社区运营，持续培养社区 KOL、布道师；",
        item2: "3. 与团队成员一起，高效落地 Authing 一系列规划，包括内容运营、用户运营、活动运营、社群运营等。",
      },
      skills: {
        item0: "1. 2 年以上技术社区运营或 B 端产品运营经验；",
        item1: "2. 具备较强的系统性思维、跨团队沟通协调能力；执行力强，抗压能力强；拥有良好的客户成功导向思维；",
        item2: "3. 快速学习能力，热爱技术，喜欢和工程师交朋友，在较短时间内能产生对数据库产品和社区成员的基本认知；",
        item3: "4. 英语优秀，有海外社区运营经验者优先；",
        item4: "5. 具有技术类高质量内容运营经验优先；",
      },
    },
    "job-19": {
      title: "总账会计",
      intro: `按照会计核算制度进行日常账务处理及账务核查管控，对全盘账务负责...`,
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 按照会计核算制度进行日常账务处理及账务核查管控，对全盘账务负责；",
        item1: "2. 进项税核对管理，开具销项税票，合理管控税负；",
        item2: "3. 监督及时申报税金、核对税金相关科目，确保当月税金准确；",
        item3: "4. 按要求完成月结相关工作，出具财务报表，保证其准确性；",
        item4: "5. 配合完成年审、税审等，以及其他相关工作；",
      },
      skills: {
        item0: "1. 985/211 本科以上学历，财务相关专业；",
        item1: "2. 有总账会计经验，有初级会计师职称，有中级会计师职称者优先；",
        item2: "3. 2 年以上工作经验，有创业公司工作经验者优先；",
        item3: "4. 思路清晰、学习及沟通能力较强，注重团队合作，有责任心、上进心，工作细致认真负责；",
        item4: "5. 熟悉最新企业会计准则，会计专业知识扎实，熟练使用 Excel 函数和数据透视表并进行数据统计和分析；",
      },
    },
    "job-20": {
      title: "SaaS 产品海外市场运营",
      intro: `英文新媒体平台、网站的日常更新与维护...`,
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 英文新媒体平台、网站的日常更新与维护；",
        item1: "2. 分析并深入洞察产业互联网，尤其是 SaaS 市场趋势，为业务负责人提供战略性发展方向指引建议；",
        item2: "3. 深入理解行业和欧美地区 SaaS 市场，协助 SaaS 产品团队发现海外市场的潜在机会点和增长点；",
        item3: "4. 分析业务数据，识别关键问题并提出改进方案；",
      },
      skills: {
        item0: "1. 本科及以上学历，至少 2 年以上相关工作经验；",
        item1: "2. 优秀的英文沟通能力，有国际团队工作经验或者留学经验优先；",
        item2: "3. 熟悉海外社交媒体和 SaaS 市场及相关行业论坛；",
        item3: "4. 工作积极主动，喜欢挑战，能承担一定的工作压力；",
      },
    },
    "job-21": {
      title: "测试工程师",
      intro: `根据产品需求和测试计划设计测试用例，执行...`,
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 根据产品需求和测试计划设计测试用例，执行测试用例，熟练运用 bug 管理工具提交和跟踪；",
        item1: "2. 完成产品的集成测试、系统测试，对产品的接口、功能等全面测试；",
        item2: "3. 根据测试过程编写相关测试报告、配合研发人员进行功能调试；",
        item3: "4. 作为业务与产品研发的中枢接口，接收、分析业务需求问题并推进产品与研发的完善；",
        item4: "5. 负责引入和完善新的测试方法提高测试效率；",
        item5: "6. 负责建立质量度量标准驱动产品质量提升；",
      },
      skills: {
        item0: "1. 3 年以上 QA 工作经验工作经验，熟悉 Web 测试；",
        item1: "2. 熟悉移动端自动化测试框架、自动化用例编写，并能对框架进行优化；",
        item2: "3. 熟悉 Android/iOS 平台特性，有一定的编程能力，熟悉 Java 语言；",
        item3: "4. 熟悉 HTTP 协议、RESTful API 及互联网应用工作原理；",
        item4: "5. 对敏捷开发及 CI/CD 有一定了解；",
        item5: "6. 有良好的沟通协作及解决问题能力，良好的执行力及推动力；",
      },
    },
    "job-22": {
      title: "商业化助理",
      intro: `进行部门销售数据的统计、整理与分析...`,
      experience: "经验 3-5 年 / 本科",
      description: {
        item0: "1. 进行部门销售数据的统计、整理与分析；",
        item1: "2. 部门销售进度的跟踪提醒，促进销售订单的达成；",
        item2: "3. 积极协同销售同学处理售前或售后相关工作；",
        item3: "4. 部门会议及客户会议的安排与组织；",
        item4: "5. 领导交办的其他临时工作；",
      },
      skills: {
        item0: "1. 本科及以上学历；",
        item1: "2. 有销售助理类工作经验者优先；",
        item2: "3. 认真负责，细心热心，善于沟通，抗压能力强；",
        item3: "4. 可接受出差；",
      },
    },
  },
  "job-detail": {
    publishtimer: "发布时间",
    "label-description": "职位描述",
    "label-skills": "职位要求",
    "label-newjob": "最新职位",
    "button-apply": "现在申请",
    navbar: {
      nav0: "关于 Authing ",
      nav1: "加入我们",
      nav2: "Node.js 研发工程师",
    },
  },
};
